import { Dispatch, SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import {
  VDO_INTEGRATION_FIELD_NAMES,
  VdoErrors
} from "../../../../../../Pages/Integrations/types";
import { VDO_INPUT_LENGTH } from "../../../../../../shared";

const useVdoIntegrationsInputs = (
  errors: VdoErrors,
  setErrors: Dispatch<SetStateAction<VdoErrors>>
) => {
  const { t } = useTranslation();

  const isNotEmpty = (value: string, field: VDO_INTEGRATION_FIELD_NAMES) => {
    const fieldTranslation = t(`Dialog##${field}`);

    return value?.trim()
      ? ""
      : t(`Dialog##field cannot be empty`, { fieldName: fieldTranslation });
  };

  const maxLength = (value: string, limit: number, msg: any) =>
    value?.trim().length > limit ? msg : "";

  const validateLength = (
    field: VDO_INTEGRATION_FIELD_NAMES,
    value: string
  ): string => {
    switch (field) {
      case VDO_INTEGRATION_FIELD_NAMES.Name:
        return maxLength(
          value,
          VDO_INPUT_LENGTH.Name,
          t("Dialog##name not valid", {
            maxNumber: VDO_INPUT_LENGTH.Name
          })
        );

      case VDO_INTEGRATION_FIELD_NAMES.ApiKey:
        return maxLength(
          value,
          VDO_INPUT_LENGTH.ApiKey,
          t("Dialog##api key cannot contain more than", {
            maxNumber: VDO_INPUT_LENGTH.ApiKey
          })
        );

      case VDO_INTEGRATION_FIELD_NAMES.AccountId:
        return maxLength(
          value,
          VDO_INPUT_LENGTH.ApiKey,
          t("Dialog##account id cannot contain more than", {
            maxNumber: VDO_INPUT_LENGTH.AccountId
          })
        );

      default:
        return "";
    }
  };

  const validateField = (
    field: VDO_INTEGRATION_FIELD_NAMES,
    value: any
  ): string => {
    switch (field) {
      case VDO_INTEGRATION_FIELD_NAMES.Name:
      case VDO_INTEGRATION_FIELD_NAMES.ApiKey:
        return isNotEmpty(value, field) || validateLength(field, value);

      default:
        return "";
    }
  };

  const handleChange = (field: VDO_INTEGRATION_FIELD_NAMES, value: any) => {
    const fieldAsErrorType = field as keyof VdoErrors;
    const lengthError = validateLength(field, value);

    setErrors(prev => ({
      ...prev,
      [fieldAsErrorType]: lengthError
    }));
  };

  const handleBlur = (field: VDO_INTEGRATION_FIELD_NAMES, value: any) => {
    setErrors(prev => ({
      ...prev,
      [field]: validateField(field, value)
    }));
  };

  const clearFieldError = (field: keyof VdoErrors) => {
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: "" }));
    }
  };

  return { handleChange, handleBlur, clearFieldError };
};

export default useVdoIntegrationsInputs;
